import EventObject from '../../modules/tracking/EventObject';

export default function () {
   const model = () => document.getElementById('modelDropdown').value || 'Search';

   const category = () => `${window.brand} Motability ${model()}`;

   const categoryWithText = text => `${category()} ${text}`;

   document.querySelectorAll('[data-quote-type]').forEach(quoteType => {
      quoteType.addEventListener('change', function() {
         const type = this.value === 'civillian' ? 'Civillian' : 'War Pensioner';
         new EventObject(category(), 'Clicked', `${type} Quote Clicked`).dispatch();
      })
   })

   document.getElementById('modelDropdown').addEventListener('change', () => {
      new EventObject(category(), 'Clicked', 'Model Dropdown Clicked').dispatch();
   });

   document.querySelectorAll('[data-sort-by]').forEach(sortBy => {
      sortBy.addEventListener('click', ({ target }) => {
         new EventObject(category(), 'Clicked', `Sorted by ${target.text}`).dispatch();
      });
   });

   document.getElementById('sort-element').addEventListener('change', ({ target }) => {
      const text = target.options[target.selectedIndex].text
      new EventObject(category(), 'Clicked', `Sorted by ${text}`).dispatch();
   });

   document.getElementById('price-slider-range').noUiSlider.on('change', ([from]) => {
      new EventObject(category(), 'Moved Slider', `Advance Payment Slider - From ${parseInt(from)}`).dispatch();
   });

   document.getElementById('nil_advance_payment').addEventListener('change', () => {
      new EventObject(categoryWithText('Promotions'), 'Clicked', 'Clicked Nil Advance Payment').dispatch();
   });

   document.getElementById('total_allowance').addEventListener('change', () => {
      new EventObject(categoryWithText('Promotions'), 'Clicked', 'Clicked Total Allowance').dispatch();
   });

   document.querySelector('#advanced-search-options-btn').addEventListener('click', () => {
      new EventObject(category(), 'Clicked', 'Clicked Advanced Search Options CTA').dispatch();
   });

   document.getElementById('trimDropdown').addEventListener('change', ({ target }) => {
      new EventObject(category(), 'Filtered', `Filtered on Trim Level - ${target.value}`).dispatch();
   });

   document.getElementById('fuelTypeDropdown').addEventListener('change', ({ target }) => {
      new EventObject(category(), 'Filtered', `Filtered on Fuel Type - ${target.value}`).dispatch();
   });

   document.getElementById('transmissionDropdown').addEventListener('change', ({ target }) => {
      new EventObject(category(), 'Filtered', `Filtered on Transmission - ${target.value}`).dispatch();
   });

   document.getElementById('bodystyleDropdown').addEventListener('change', ({ target }) => {
      new EventObject(category(), 'Filtered', `Filtered on Body Style - ${target.value}`).dispatch();
   });

   document.getElementById('engineSizeDropdown').addEventListener('change', ({ target }) => {
      new EventObject(category(), 'Filtered', `Filtered on Engine Size - ${target.value}`).dispatch();
   });

   document.getElementById('co2Dropdown').addEventListener('change', ({ target }) => {
      new EventObject(category(), 'Filtered', `Filtered on CO2 Emissions - ${target.value}`).dispatch();
   });

   document.getElementById('doorsDropdown').addEventListener('change', ({ target }) => {
      new EventObject(category(), 'Filtered', `Filtered on Number of doors - ${target.value}`).dispatch();
   });

   document.getElementById('mpg_combinedDropdown').addEventListener('change', ({ target }) => {
      new EventObject(category(), 'Filtered', `Filtered on Fuel Consumption - ${target.value}`).dispatch();
   });

   document.getElementById('seatsDropdown').addEventListener('change', ({ target }) => {
      new EventObject(category(), 'Filtered', `Filtered on Number of Seats - ${target.value}`).dispatch();
   });
}